import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class BadRequestErrorService {
  /**
   * @ignore
   */
  constructor(private translate: TranslateService) {}

  /**
   * Bads request error
   * @param errorCode
   * @returns message error
   */
  badRequestError(errorCode): string {
    let message = this.translate.instant('errors.ERROR_CONFLICT');

    let errors = Object.keys(BadRequestError).map(
      (key) => BadRequestError[key]
    );

    if (errors.some((e) => e[0] === errorCode)) {
      let err = errors.find((e) => e[0] === errorCode);
      return this.translate.instant(err[1]);
    }

    return message;
  }
}
/**
 * @ignore
 */
export const BadRequestError = {
  ERROR_BAD_REQUEST: {},
  ERROR_BAD_REQUEST_MISSING_FILE_DATA: {},
  ERROR_BAD_REQUEST_PRESET_NOT_ASSIGNED_TO_FRAME: {},
  ERROR_BAD_REQUEST_NON_MATCHING_PASSWORDS: {},
  ERROR_BAD_REQUEST_DMS_INVALID_CREDENTIALS: {},
  ERROR_BAD_REQUEST_EXCEEDED_EXTERIOR_COUNT: {},
  ERROR_CONFLICT_DUPLICATE_USER: {},
  ERROR_CONFLICT_DUPLICATE_USER_EMAIL: {},
  ERROR_BAD_REQUEST_NO_IMAGES_TO_PROCESS: {},
  ERROR_BAD_REQUEST_NO_COLLAGES_TO_PROCESS: {},
  ERROR_BAD_REQUEST_COLLAGE_MISSING_POSITIONS: {},
  ERROR_BAD_REQUEST_MAXIMUM_NUMBER_API_CALLS: {},
  ERROR_BAD_REQUEST_VALIDATION_ERROR: {},
  ERROR_BAD_REQUEST_INVALID_IMAGE_TYPE: {},
  ERROR_BAD_REQUEST_USE_CLIENT_CREDITS: {},
  ERROR_BAD_REQUEST_DEFAULT_BACKGROUND_NOT_SET: {},
  ERROR_DECODE_VIN: {},
};

BadRequestError.ERROR_BAD_REQUEST = [4000000, 'errors.ERROR_BAD_REQUEST'];
BadRequestError.ERROR_BAD_REQUEST_MISSING_FILE_DATA = [
  4000001,
  'errors.ERROR_BAD_REQUEST_MISSING_FILE_DATA',
];
BadRequestError.ERROR_BAD_REQUEST_PRESET_NOT_ASSIGNED_TO_FRAME = [
  4000002,
  'errors.ERROR_BAD_REQUEST_PRESET_NOT_ASSIGNED_TO_FRAME',
];
BadRequestError.ERROR_BAD_REQUEST_NON_MATCHING_PASSWORDS = [
  4000004,
  'errors.ERROR_BAD_REQUEST_NON_MATCHING_PASSWORDS',
];
BadRequestError.ERROR_BAD_REQUEST_DMS_INVALID_CREDENTIALS = [
  4000006,
  'errors.ERROR_BAD_REQUEST_DMS_INVALID_CREDENTIALS',
];
BadRequestError.ERROR_BAD_REQUEST_EXCEEDED_EXTERIOR_COUNT = [
  4000007,
  'errors.ERROR_BAD_REQUEST_EXCEEDED_EXTERIOR_COUNT',
];
BadRequestError.ERROR_BAD_REQUEST_NO_IMAGES_TO_PROCESS = [
  4000008,
  'errors.ERROR_BAD_REQUEST_NO_IMAGES_TO_PROCESS',
];
BadRequestError.ERROR_BAD_REQUEST_NO_COLLAGES_TO_PROCESS = [
  4000010,
  'errors.ERROR_BAD_REQUEST_NO_COLLAGES_TO_PROCESS',
];
BadRequestError.ERROR_BAD_REQUEST_COLLAGE_MISSING_POSITIONS = [
  4000011,
  'errors.ERROR_BAD_REQUEST_COLLAGE_MISSING_POSITIONS',
];
BadRequestError.ERROR_BAD_REQUEST_MAXIMUM_NUMBER_API_CALLS = [
  4000012,
  'errors.ERROR_BAD_REQUEST_MAXIMUM_NUMBER_API_CALLS',
];
BadRequestError.ERROR_BAD_REQUEST_VALIDATION_ERROR = [
  4000013,
  'errors.ERROR_BAD_REQUEST_VALIDATION_ERROR',
];
BadRequestError.ERROR_BAD_REQUEST_INVALID_IMAGE_TYPE = [
  4000014,
  'errors.ERROR_BAD_REQUEST_INVALID_IMAGE_TYPE',
];
BadRequestError.ERROR_BAD_REQUEST_USE_CLIENT_CREDITS = [
  4000022,
  'errors.ERROR_BAD_REQUEST_USE_CLIENT_CREDITS',
];
BadRequestError.ERROR_BAD_REQUEST_DEFAULT_BACKGROUND_NOT_SET = [
  4000025,
  'errors.ERROR_BAD_REQUEST_DEFAULT_BACKGROUND_NOT_SET',
];
BadRequestError.ERROR_DECODE_VIN = [4000034, 'errors.ERROR_DECODE_VIN'];
